// removed by extract-text-webpack-plugin
module.exports = {"absolute-center":"onfido-sdk-ui-ProofOfAddress-PoAIntro-absolute-center","content":"onfido-sdk-ui-ProofOfAddress-PoAIntro-content","requirements":"onfido-sdk-ui-ProofOfAddress-PoAIntro-requirements","requirement":"onfido-sdk-ui-ProofOfAddress-PoAIntro-requirement","bolder":"onfido-sdk-ui-ProofOfAddress-PoAIntro-bolder"};


//////////////////
// WEBPACK FOOTER
// ./components/ProofOfAddress/PoAIntro/style.css
// module id = 383
// module chunks = 1